import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { green } from '@mui/material/colors';
import React from 'react';
import toast from 'react-hot-toast';
import { IWizardFormStep } from 'src/interface/interface';
import { useOrderDataStore } from 'src/zustandStore/store.order-data';
import { useOrderManagementStore } from 'src/zustandStore/store.ordermgt';
import { useDiscountAPI } from '../../../../hooks/useDiscountAPI';
import { useOrderMgt } from '../../../../hooks/useOrderMgt';
import { formatAddress } from '../../../../Utils';

export const SummaryStepForm = (props: IWizardFormStep) => {
  const orderData = useOrderDataStore((state) => state);
  const orderManagement = useOrderManagementStore((state) => state);
  const orders = orderData.settings.orders;
  const [loading, setLoading] = React.useState(false);
  const [discountCodes, setDiscountCodes] = React.useState<string[]>([]);
  const { onPrevious } = props;
  const { submitOrderRequest } = useOrderMgt();
  const { verifyDiscountCode, verificationLoading, error, clearError } =
    useDiscountAPI();

  const handleBack = () => {
    // Implement back button logic here
    onPrevious();
  };
  const handleNext = () => {
    // Implement next button logic here
    setLoading(true);
    submitOrderRequest({
      email: orderManagement.settings.authUser.email,
      discountCodes: discountCodes,
      order: orderData.settings.orders.map((order) => {
        return {
          addressId: orderData.settings.address.id,
          amountPaid: order.amountPaid,
          notes: order.notes,
          quantity: order.quantity,
          variantId: order.variantId,
          discountCodes: discountCodes.length > 0 ? discountCodes : ['']
        };
      })
    })
      .then((response) => {
        if (
          response !== null &&
          response.status >= 200 &&
          response.status < 300
        ) {
          toast('Order created successfully!');
          setTimeout(() => {
            window.location.href = '/orders/';
          }, 2000);
        } else {
          toast('Failed to create order. Please try again.');
          console.error('Failed to create order:', response);
        }
      })
      .catch((error) => {
        toast(error.message || 'An error occurred while creating the order.');
        console.error('Error creating order:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {/* Display form-level errors if any */}

      <Grid
        sx={{
          flexDirection: 'column',
          gap: 2,
          width: 'auto'
        }}
        spacing={3}
      >
        <Grid spacing={3}>
          <Box
            sx={{
              padding: '2% 2%',
              width: '100%',
              border: '1px solid #e0e0e0',
              borderRadius: '8px'
            }}
          >
            <Box sx={{ mt: 3 }}>
              <div className="order-delivery-card">
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  className="order-delivery-info-item"
                >
                  <span>Buyer:</span>
                  <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {orderManagement.settings?.authUser?.name || 'N/A'}
                  </span>
                </Typography>

                {/* Vendor Details */}
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  className="order-delivery-info-item"
                >
                  <span>Address:</span>

                  <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {formatAddress(orderData?.settings.address || 'N/A')}
                  </span>
                </Typography>
              </div>
            </Box>
            <TableContainer sx={{ mb: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Product Name</TableCell>
                    <TableCell>Price</TableCell>
                    <TableCell>Qty</TableCell>
                    <TableCell>Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.length ? (
                    <>
                      {orders.map((order, index) => (
                        <TableRow
                          key={index}
                          onClick={() => {}}
                          sx={{
                            cursor: 'pointer'
                          }}
                        >
                          <TableCell>{order.productName}</TableCell>
                          <TableCell>{order.amountPaid}</TableCell>
                          <TableCell>{order.quantity}</TableCell>
                          <TableCell>
                            {order.amountPaid * order.quantity}
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        No items available for this order.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box>
              {/*  Discount Codes*/}

              <Typography variant="subtitle1" gutterBottom>
                Discount Codes
              </Typography>

              <Box
                sx={{
                  width: '100%',
                  mb: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2
                }}
              >
                <TextField
                  onBlur={(e) => {
                    const codes = e.target.value
                      .split(',')
                      .map((code) => code.trim());
                    setDiscountCodes(codes);
                  }}
                  placeholder="Enter discount code"
                  multiline
                  rows={2}
                />
                <label htmlFor="">
                  Discount codes should be seperated by commas
                </label>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    mt: 1
                  }}
                >
                  {discountCodes.map((code) => (
                    <Chip
                      sx={{
                        backgroundColor: '#f0f0f0',
                        color: '#333',
                        fontSize: '0.875rem',
                        height: '32px'
                      }}
                      label={code}
                      variant={'outlined'}
                    />
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 3,
          mt: 5
        }}
        className="wizard-button"
      >
        <Button variant={'contained'} onClick={() => handleBack()}>
          Previous
        </Button>

        {}
        <Button
          disabled={orders.length === 0 && error !== null}
          variant={'contained'}
          onClick={() => handleNext()}
        >
          Create Order
          {loading && (
            <CircularProgress
              size={20}
              sx={{
                color: green[500],
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-12px',
                marginLeft: '-12px'
              }}
            />
          )}
        </Button>
      </Box>
    </>
  );
};
